<template>
  <div class="c-mid-head">
    <n-link v-if="hasBackRoute" :to="{name: backRoute, query: { type: type }}" class="c-back-row-button">
      <img :src="backRowIcon" alt="" class="back-row-icon">
    </n-link>
    <div class="mid-headers">
      <h1>{{ h1 }}</h1>
      <h2 v-if="h2">{{ h2 }}</h2>
    </div>
  </div>
</template>

<script>
import backRowIcon from 'assets/backRow/back-row.png'

export default {
  name: 'CMidHead',
  props: {
    backRoute: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: '',
    },
    h1: {
      type: String,
      required: true,
    },
    h2: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      backRowIcon,
      hasBackRoute: this.backRoute,
    }
  },
  created() {
    if (this.backRoute === '') {
      this.hasBackRoute = false
    }
  },
}
</script>

<style scoped lang="scss">
.c-mid-head {
  display: flex;
  alignment: center;

  .c-back-row-button {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 19px 0 7px;

    .c-back-row-icon {
      width: 18px;
      height: 14px;
    }
  }

  .mid-headers {
    h1 {
      text-align: left;
      vertical-align: center;
      font-size: 17px;
      font-weight: bold;
      color: #000000;
      padding: 0;
      margin: 0;
    }

    h2 {
      padding: 0;
      margin: 0;
      font-size: 14px;
      color: #626C77;
    }
  }
}
</style>
